<template>
  <v-app>
    <!-- Intro-area -->
    <div ref="myDiv" style="z-index: 1">
           <kinesis-container
            event="scroll">
      <v-container fluid grid-list-md style="max-width: 1185px" class="py-0">
        <v-layout row wrap>
          <v-flex xs12 sm12 md5 lg5 class="py-5 px-3 hidden-sm-and-down">
            <v-card style flat>
              <kinesis-element  :strength="300"
                          type="translate"
                          axis="y">

                          <!-- style="
                  width: 40%;
                  height: 30%;
                  display: block;
                  position: absolute;
                  top: 0;
                  left: 0;
                  right: 0;
                  bottom: 0;
                  content: '';
                  z-index: -1;
                  background: rgba(175, 205, 255, 0.556);
                  margin-top: 40px;
                  margin-left: -60px;
                  opacity: 1;
                " -->
              <v-card
              class="bounce-enter-active"
                style="
                  width: 60px;
                  height: 250px;
                  display: block;
                  position: absolute;
                  top: 0;
                  left: 0;
                  right: 0;
                  bottom: 0;
                  content: '';
                  z-index: -1;
                  background: rgba(175, 205, 255, 0.556);
                  margin-top: 150px;
                  margin-left: -60px;
                  opacity: 1;
                "
              ></v-card>
              </kinesis-element>
              
              <img
                class="pt-0 elevation-10"
                style="max-width: 95%; max-height: 95%"
                src="/img/Nicholas.png"
                alt
                
              />
              
            </v-card>
          </v-flex>
          <v-flex xs12 md7 lg7 class="py-3 px-4 hidden-xs-only">
            <v-layout  align-start  justify-center row wrap  class="py-4">
              <v-flex xs12 d-flex>
                <v-card class="py-3" flat>
                  <h2
                    class="mb-3"
                    style="font-size: 34px; text-transform: capitalize"
                  >
                    About Us
                  </h2>
                  <p>
                    We are Everowl Technologies, a small but enthusiastic
                    company that specializes in both mobile and website
                    development. We come together for a sole purpose which is to
                    help others fulfil their goals and aspiration through
                    software development.
                    <br />
                    <br />With a motivated team driving the engine behind
                    Everowl Technologies, we strive to be the creative
                    developers that bring a smile to your face. Which is why we
                    are always looking at new innovative ways to get the best
                    for you.
                    <br />
                    <br />The working culture surrounding us encourages to work
                    pass the average working hours. Our passion and commitment
                    help us stay up through the late nights to ensure there are
                    no compromises. Hence, that explains why would chose an Owl
                    as our company's mascot 🦉.
                  </p>
                </v-card>
              </v-flex>
              <v-flex xs12 sm6>
                <v-card class="pr-3 py-3" flat>
                  <img
                    class="my-1"
                    style="max-width: 35px; height: auto"
                    src="/img/FireIcon.svg"
                    alt
                  />
                  <h3 class="heading mt-0 mb-2">Passion</h3>
                  <p>
                    We are passionate in technology and learning the new trends
                    that technology have in store for us to improve our quality
                    of life.
                  </p>
                </v-card>
              </v-flex>
              <v-flex xs12 sm6>
                <v-card class="pl-2 py-3" flat>
                  <img
                    class="my-1 pt-2"
                    style="max-width: 55px; height: auto"
                    src="/img/HandShakeIcon.svg"
                    alt
                  />
                  <h3 class="heading mt-0 mb-2">Humility</h3>
                  <p>
                    We understand we are nothing without the support and trust
                    you have provided for us. Therefore, we truly appreciate and
                    are grateful for this oppurtunity.
                  </p>
                </v-card>
              </v-flex>
              <v-flex xs12>
                <v-card class="py-3" flat>
                  <img
                    class="my-1"
                    style="max-width: 50px; height: auto"
                    src="/img/HighFiveIcon.svg"
                    alt
                  />
                  <h3 class="heading mt-0 mb-2">Teamwork</h3>
                  <p>
                    We reserve nothing when it comes to sharing our expertise
                    among ourselves. There's nothing better than sitting down
                    with the people you like and respect, pitching and
                    contributing our respective ideas and perspectives to
                    achieve greatness.
                  </p>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 md7 lg7 class="px-4 hidden-sm-and-up text-xs-center">
            <v-layout align-center justify-center row wrap class="pb-4">
              <v-flex xs12 d-flex>
                <v-card class="pb-2" flat>
                  <h2
                    class="my-2"
                    style="font-size: 34px; text-transform: capitalize"
                  >
                    About Me
                  </h2>
                  <p>
                    We are Everowl Technologies, a small but enthusiastic
                    company that specializes in both mobile and website
                    development. We come together for a sole purpose which is to
                    help others fulfil their goals and aspiration through
                    software development.
                    <br />
                    <br />With a motivated team driving the engine behind
                    Everowl Technologies, we strive to be the creative
                    developers that bring a smile to your face. Which is why we
                    are always looking at new innovative ways to get the best
                    for you.
                    <br />
                    <br />The working culture surrounding us encourages to work
                    pass the average working hours. Our passion and commitment
                    help us stay up through the late nights to ensure there are
                    no compromises. Hence, that explains why would chose an Owl
                    as our company's mascot 🦉.
                  </p>
                </v-card>
              </v-flex>
              <v-flex xs10>
                <v-card class="py-3" flat>
                  <img
                    class="my-1"
                    style="max-width: 38px; height: auto"
                    src="/img/FireIcon.svg"
                    alt
                  />
                  <h3 class="heading mt-0 mb-2">Passion</h3>
                  <p>
                    We are passionate in technology and learning the new trends
                    that technology have in store for us to improve our quality
                    of life.
                  </p>
                </v-card>
              </v-flex>
              <v-flex xs10>
                <v-card class="py-3" flat>
                  <img
                    class="my-1"
                    style="max-width: 50px; height: auto"
                    src="/img/HandShakeIcon.svg"
                    alt
                  />
                  <h3 class="heading mt-0 mb-2">Humility</h3>
                  <p>
                    We understand we are nothing without the support and trust
                    you have provided for us. Therefore, we truly appreciate and
                    are grateful for this oppurtunity.
                  </p>
                </v-card>
              </v-flex>
              <v-flex xs10>
                <v-card class="py-3" flat>
                  <img
                    class="my-1"
                    style="max-width: 50px; height: auto"
                    src="/img/HighFiveIcon.svg"
                    alt
                  />
                  <h3 class="heading mt-0 mb-2">Teamwork</h3>
                  <p>
                    We reserve nothing when it comes to sharing our expertise
                    among ourselves. There's nothing better than sitting down
                    with the people you like and respect, pitching and
                    contributing our respective ideas and perspectives to
                    achieve greatness.
                  </p>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
           </kinesis-container>
    </div>
    <!-- Intro-area -->

    <!-- Body-Intro-area -->
    <div class="text-xs-center">
      <v-container style="max-width: 700px" class="py-0">
        <v-flex class="hidden-sm-and-down">
          <div class="customdividermini mt-5 mb-4"></div>
          <h3 class="py-2">
            <span class="font-italic pr-1">EverOwl</span> is a group of friends
            <br />with a passion of turning goals into reality. <br />And its
            just the beginning.
          </h3>
          <div class="customdividermini my-4"></div>
        </v-flex>

        <v-flex class="hidden-md-and-up px-4">
          <div class="customdividermini mt-4 mb-4" style="width: 120px"></div>
          <p style="font-size: 20px !important">
            <span class="font-italic pr-1">EverOwl</span> is inspired & created
            with style for those who want to express and share their ability yet
            beyond from day to day.
          </p>
          <div class="customdividermini mt-4 mb-5" style="width: 120px"></div>
        </v-flex>
      </v-container>
    </div>
    <!-- Body-Intro-area -->

    <!-- Body-area (Nagivation)-->
    <v-container class="my-4 px-2" style="max-width: 1185px; z-index: 1">
      <v-flex class="px-4 hidden-sm-and-down">
        <div class="space-20"></div>
        <h2 class="ma-0">
          Our Area Of Expertise
        </h2>
        <div class="space-20"></div>
      </v-flex>
      <v-flex class="px-4 hidden-md-and-up text-xs-center">
        <h3 class="ma-0">
          Our Area Of Expertise
        </h3>
      </v-flex>
      <v-layout text-xs-center align-center justify-center row wrap>
        <v-flex xs12 sm6 md3 class="py-3 px-2">
          <a @click="toPage('Web Development')" class="transformCard education">
            <div class="transformCardOverlay"></div>
            <div class="transformCardCircle">
              <svg
                width="71px"
                height="76px"
                viewBox="29 14 71 76"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <g
                  id="Group"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                  transform="translate(30.000000, 14.000000)"
                >
                  <g id="Group-8" fill="#D98A19">
                    <g id="Group-7">
                      <g id="Group-6">
                        <path
                          d="M0,0 L0,75.9204805 L69.1511499,75.9204805 L0,0 Z M14.0563973,32.2825679 L42.9457663,63.9991501 L14.2315268,63.9991501 L14.0563973,32.2825679 Z"
                          id="Fill-1"
                        ></path>
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group-20"
                    transform="translate(0.000000, 14.114286)"
                    stroke="#FFFFFF"
                    stroke-linecap="square"
                  >
                    <path
                      d="M0.419998734,54.9642857 L4.70316223,54.9642857"
                      id="Line"
                    ></path>
                    <path
                      d="M0.419998734,50.4404762 L4.70316223,50.4404762"
                      id="Line"
                    ></path>
                    <path
                      d="M0.419998734,45.9166667 L4.70316223,45.9166667"
                      id="Line"
                    ></path>
                    <path
                      d="M0.419998734,41.3928571 L2.93999114,41.3928571"
                      id="Line"
                    ></path>
                    <path
                      d="M0.419998734,36.8690476 L4.70316223,36.8690476"
                      id="Line"
                    ></path>
                    <path
                      d="M0.419998734,32.3452381 L4.70316223,32.3452381"
                      id="Line"
                    ></path>
                    <path
                      d="M0.419998734,27.8214286 L4.70316223,27.8214286"
                      id="Line"
                    ></path>
                    <path
                      d="M0.419998734,23.297619 L2.93999114,23.297619"
                      id="Line"
                    ></path>
                    <path
                      d="M0.419998734,18.7738095 L4.70316223,18.7738095"
                      id="Line"
                    ></path>
                    <path
                      d="M0.419998734,14.25 L4.70316223,14.25"
                      id="Line"
                    ></path>
                    <path
                      d="M0.419998734,9.72619048 L4.70316223,9.72619048"
                      id="Line"
                    ></path>
                    <path
                      d="M0.419998734,5.20238095 L2.93999114,5.20238095"
                      id="Line"
                    ></path>
                    <path
                      d="M0.419998734,0.678571429 L4.70316223,0.678571429"
                      id="Line"
                    ></path>
                  </g>
                </g>
              </svg>
            </div>
            <p class="subheading font-weight-light">Website Design</p>
          </a>
        </v-flex>

        <v-flex xs12 sm6 md3 class="py-3">
          <a @click="toPage('App Development')" class="transformCard wallet">
            <div class="transformCardOverlay"></div>
            <div class="transformCardCircle">
              <svg
                width="78px"
                height="60px"
                viewBox="23 29 78 60"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <g
                  id="icon"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                  transform="translate(23.000000, 29.500000)"
                >
                  <rect
                    id="Rectangle-3"
                    fill="#AC8BE9"
                    x="67.8357511"
                    y="26.0333433"
                    width="9.40495664"
                    height="21.8788565"
                    rx="4.70247832"
                  ></rect>
                  <rect
                    id="Rectangle-3"
                    fill="#6A5297"
                    x="67.8357511"
                    y="38.776399"
                    width="9.40495664"
                    height="10.962961"
                    rx="4.70247832"
                  ></rect>
                  <polygon
                    id="Rectangle-2"
                    fill="#6A5297"
                    points="57.3086772 0 67.1649301 26.3776902 14.4413177 45.0699507 4.58506484 18.6922605"
                  ></polygon>
                  <path
                    d="M0,19.6104296 C0,16.2921718 2.68622235,13.6021923 5.99495032,13.6021923 L67.6438591,13.6021923 C70.9547788,13.6021923 73.6388095,16.2865506 73.6388095,19.6104296 L73.6388095,52.6639057 C73.6388095,55.9821635 70.9525871,58.672143 67.6438591,58.672143 L5.99495032,58.672143 C2.68403068,58.672143 0,55.9877847 0,52.6639057 L0,19.6104296 Z"
                    id="Rectangle"
                    fill="#8B6FC0"
                  ></path>
                  <path
                    d="M47.5173769,27.0835169 C45.0052827,24.5377699 40.9347162,24.5377699 38.422622,27.0835169 L36.9065677,28.6198808 L35.3905134,27.0835169 C32.8799903,24.5377699 28.8078527,24.5377699 26.2957585,27.0835169 C23.7852354,29.6292639 23.7852354,33.7559532 26.2957585,36.3001081 L36.9065677,47.0530632 L47.5173769,36.3001081 C50.029471,33.7559532 50.029471,29.6292639 47.5173769,27.0835169"
                    id="Fill-12"
                    fill="#F6F1FF"
                  ></path>
                  <rect
                    id="Rectangle-4"
                    fill="#AC8BE9"
                    x="58.0305835"
                    y="26.1162588"
                    width="15.6082259"
                    height="12.863158"
                  ></rect>
                  <ellipse
                    id="Oval"
                    fill="#FFFFFF"
                    cx="65.8346965"
                    cy="33.0919007"
                    rx="2.20116007"
                    ry="2.23319575"
                  ></ellipse>
                </g>
              </svg>
            </div>
            <p class="subheading font-weight-light">Mobile Application</p>
          </a>
        </v-flex>

        <v-flex xs12 sm6 md3 class="py-3">
          <a @click="toCMSSection()" class="transformCard credentialing">
            <div class="transformCardOverlay"></div>
            <div class="transformCardCircle">
              <svg
                width="64px"
                height="72px"
                viewBox="27 21 64 72"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <g
                  id="Group-12"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                  transform="translate(27.000000, 21.000000)"
                >
                  <g id="Group-5">
                    <g id="Group-3" transform="translate(2.262327, 21.615176)">
                      <mask id="mask-2" fill="white">
                        <use xlink:href="#path-1"></use>
                      </mask>
                      <g id="Clip-2"></g>
                      <path
                        d="M7.17774177,18.4748913 L54.3387782,18.4748913 C57.9910226,18.4748913 60.9789911,15.7266455 60.9789911,12.3681986 L60.9789911,6.13665655 C60.9789911,2.77820965 57.9910226,0.0299638385 54.3387782,0.0299638385 L7.17774177,0.0299638385 C3.52634582,0.0299638385 0.538377293,2.77820965 0.538377293,6.13665655 L0.538377293,12.3681986 C0.538377293,15.7266455 3.52634582,18.4748913 7.17774177,18.4748913"
                        id="Fill-1"
                        fill="#59A785"
                        mask="url(#mask-2)"
                      ></path>
                    </g>
                    <polygon
                      id="Fill-4"
                      fill="#FFFFFF"
                      transform="translate(31.785111, 30.877531) rotate(-2.000000) translate(-31.785111, -30.877531) "
                      points="62.0618351 55.9613216 7.2111488 60.3692832 1.50838775 5.79374073 56.3582257 1.38577917"
                    ></polygon>
                    <ellipse
                      id="Oval-3"
                      fill="#25D48A"
                      opacity="0.216243004"
                      cx="30.0584472"
                      cy="21.7657707"
                      rx="9.95169733"
                      ry="9.17325562"
                    ></ellipse>
                    <g
                      id="Group-4"
                      transform="translate(16.959615, 6.479082)"
                      fill="#54C796"
                    >
                      <polygon
                        id="Fill-6"
                        points="10.7955395 21.7823628 0.11873799 11.3001058 4.25482787 7.73131106 11.0226557 14.3753897 27.414824 1.77635684e-15 31.3261391 3.77891399"
                      ></polygon>
                    </g>
                    <path
                      d="M4.82347935,67.4368303 L61.2182039,67.4368303 C62.3304205,67.4368303 63.2407243,66.5995595 63.2407243,65.5765753 L63.2407243,31.3865871 C63.2407243,30.3636029 62.3304205,29.5263321 61.2182039,29.5263321 L4.82347935,29.5263321 C3.71126278,29.5263321 2.80095891,30.3636029 2.80095891,31.3865871 L2.80095891,65.5765753 C2.80095891,66.5995595 3.71126278,67.4368303 4.82347935,67.4368303"
                      id="Fill-8"
                      fill="#59B08B"
                    ></path>
                    <path
                      d="M33.3338063,67.4368303 L61.2181191,67.4368303 C62.3303356,67.4368303 63.2406395,66.5995595 63.2406395,65.5765753 L63.2406395,31.3865871 C63.2406395,30.3636029 62.3303356,29.5263321 61.2181191,29.5263321 L33.3338063,29.5263321 C32.2215897,29.5263321 31.3112859,30.3636029 31.3112859,31.3865871 L31.3112859,65.5765753 C31.3112859,66.5995595 32.2215897,67.4368303 33.3338063,67.4368303"
                      id="Fill-10"
                      fill="#4FC391"
                    ></path>
                    <path
                      d="M29.4284029,33.2640869 C29.4284029,34.2202068 30.2712569,34.9954393 31.3107768,34.9954393 C32.3502968,34.9954393 33.1931508,34.2202068 33.1931508,33.2640869 C33.1931508,32.3079669 32.3502968,31.5327345 31.3107768,31.5327345 C30.2712569,31.5327345 29.4284029,32.3079669 29.4284029,33.2640869"
                      id="Fill-15"
                      fill="#FEFEFE"
                    ></path>
                    <path
                      d="M8.45417501,71.5549073 L57.5876779,71.5549073 C60.6969637,71.5549073 63.2412334,69.2147627 63.2412334,66.3549328 L63.2412334,66.3549328 C63.2412334,63.4951029 60.6969637,61.1549584 57.5876779,61.1549584 L8.45417501,61.1549584 C5.34488919,61.1549584 2.80061956,63.4951029 2.80061956,66.3549328 L2.80061956,66.3549328 C2.80061956,69.2147627 5.34488919,71.5549073 8.45417501,71.5549073"
                      id="Fill-12"
                      fill="#5BD6A2"
                    ></path>
                  </g>
                </g>
              </svg>
            </div>
            <p class="subheading font-weight-light">
              Content Management System
            </p>
          </a>
        </v-flex>

        <v-flex xs12 sm6 md3 class="py-3">
          <a
            @click="toPage('Contact Us')"
            class="transformCard human-resources"
          >
            <div class="transformCardOverlay"></div>
            <div class="transformCardCircle">
              <svg
                width="66px"
                height="77px"
                viewBox="1855 26 66 77"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <g
                  id="Page-1"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                  transform="translate(1855.000000, 26.000000)"
                >
                  <path
                    d="M4.28872448,42.7464904 C4.28872448,39.3309774 5.4159227,33.7621426 6.40576697,30.4912557 C10.5920767,32.1098991 14.3021264,35.1207513 18.69596,35.1207513 C30.993618,35.1207513 42.5761396,28.7162991 49.9992251,17.9014817 C56.8027248,23.8881252 60.8188351,33.0463165 60.8188351,42.7464904 C60.8188351,60.817447 47.6104607,76.6693426 32.5537798,76.6693426 C17.4970989,76.6693426 4.28872448,60.817447 4.28872448,42.7464904"
                    id="Fill-8"
                    fill="#AFCEFF"
                  ></path>
                  <path
                    d="M64.3368879,31.1832696 L62.8424171,46.6027478 L60.6432609,46.7824348 L59.8340669,34.6791304 L47.6573402,25.3339478 C44.2906753,34.068487 34.3459503,40.2903304 24.4684093,40.2903304 C17.7559812,40.2903304 10.046244,37.4168 5.80469412,32.8004522 L5.80469412,34.6791304 L5.80469412,46.6027478 L4.28932167,46.6027478 L1.30187314,27.8802435 C1.30187314,20.9790957 3.52342407,15.5432 7.27229127,11.3578087 C13.132229,4.79558261 21.8124018,0.0492173913 30.5672235,0.342852174 C37.4603019,0.569286957 42.6678084,2.72991304 50.8299179,0.342852174 C51.4629405,1.44434783 51.8615656,3.00455652 51.5868577,5.22507826 C51.4629405,6.88316522 51.2106273,7.52302609 50.8299179,8.45067826 C58.685967,14.1977391 64.3368879,20.7073739 64.3368879,31.1832696"
                    id="Fill-10"
                    fill="#3B6CB7"
                  ></path>
                  <path
                    d="M58.9405197,54.5582052 C62.0742801,54.8270052 65.3603242,52.60064 65.6350321,49.5386574 C65.772386,48.009127 65.2617876,46.5570226 64.3182257,45.4584487 C63.3761567,44.3613357 62.0205329,43.6162922 60.4529062,43.4818922 L58.9405197,54.5582052 Z"
                    id="Fill-13"
                    fill="#568ADC"
                  ></path>
                  <path
                    d="M6.32350389,54.675367 C3.18227865,54.8492104 0.484467804,52.4957496 0.306803449,49.4264626 C0.217224782,47.8925496 0.775598471,46.4579757 1.75200594,45.3886191 C2.7284134,44.3192626 4.10792487,43.6165843 5.67853749,43.530393 L6.32350389,54.675367 Z"
                    id="Fill-15"
                    fill="#568ADC"
                  ></path>
                </g>
              </svg>
            </div>
            <p class="subheading font-weight-light">IT Solution</p>
          </a>
        </v-flex>
      </v-layout>
    </v-container>
    <!-- Body-area (Nagivation)-->

    <!--The Team-->
    <v-container class="my-4 px-2" style="max-width: 1185px; z-index: 1">
      <h2 class="ma-0 px-4">
        Dedicated Team Members
      </h2>
      <div class="space-20"></div>
      <v-layout justify-center style="z-index: 1" wrap row>
        <v-flex xs12 sm6 md3 class="py-3">
          <GameCards
            data-image="/img/avatar/Kelf.jpg"
          >
            <h2
              slot="header"
              style="
                font-size: 3.3125rem !important;
                line-height: 1.15em !important;
              "
            >
              Kelf
            </h2>
            <p slot="content">Lead front-end engineer and creative director.</p>
            <v-btn
              @click="openDetail('kelf')"
              slot="btn"
              outline
              small
              style="float: right"
              >About Kelf</v-btn
            >
          </GameCards>
        </v-flex>
        <v-flex xs12 sm6 md3 class="py-3">
          <GameCards
            data-image="/img/avatar/Don.jpg"
          >
            <h2
              slot="header"
              style="
                font-size: 3.3125rem !important;
                line-height: 1.15em !important;
              "
            >
              Don
            </h2>
            <p slot="content">
              Lead back-end engineer and mobile developer expert.
            </p>
            <v-btn
              @click="openDetail('don')"
              slot="btn"
              outline
              small
              style="float: left"
              >About Don</v-btn
            >
          </GameCards>
        </v-flex>
        <v-flex xs12 sm6 md3 class="py-3">
          <GameCards
            data-image="/img/avatar/Nic.jpg"
          >
            <h2
              slot="header"
              style="
                font-size: 3.3125rem !important;
                line-height: 1.15em !important;
              "
            >
              Nick
            </h2>
            <p slot="content">Lead application analyst and system architect.</p>
            <v-btn
              @click="openDetail('nick')"
              slot="btn"
              outline
              small
              style="float: right"
              >About Nick</v-btn
            >
          </GameCards>
        </v-flex>
        <v-flex xs12 sm6 md3 class="py-3">
          <GameCards
            data-image="/img/avatar/Wilson.jpg"
          >
            <h2
              slot="header"
              style="
                font-size: 3.3125rem !important;
                line-height: 1.15em !important;
              "
            >
              Wilson
            </h2>
            <p slot="content">Lead sales representative and system designer.</p>
            <v-btn
              @click="openDetail('wilson')"
              slot="btn"
              outline
              small
              style="float: left"
              >About Wilson</v-btn
            >
          </GameCards>
        </v-flex>
      </v-layout>
    </v-container>
    <!--The Team-->

    <!-- Gallery (No pictures at the moment)-->
    <!-- <v-container class="my-4 px-2" style="max-width: 1185px; z-index:1">
      <v-flex class="hidden-sm-and-down text-xs-right">
        <div class="space-20"></div>
        <h2 class="ma-0">
          Hey look, That's us!
          <span class="caption pl-1">(And that's me!)</span>
        </h2>
      </v-flex>

      <v-flex class="px-4 hidden-md-and-up text-xs-center">
        <h2 class="ma-0">
          Hey look, That's us!
          <span class="caption pl-1">(And that's me!)</span>
        </h2>
      </v-flex>
      <div class="space-20"></div>

      <v-layout
        align-center
        justify-center
        row
        wrap
        class="containerteamimg px-3"
        style="z-index:1"
      >
        <v-flex class="wrapperteamimg pa-3" xs11 sm6 lg4>
          <div class="cardteamimg">
            <v-icon class="fal">mdi-arrow-right</v-icon>
          </div>
        </v-flex>
        <v-flex class="wrapperteamimg pa-3" xs11 sm6 lg4>
          <div class="cardteamimg">
            <v-icon class="fal">mdi-arrow-right</v-icon>
          </div>
        </v-flex>
        <v-flex class="wrapperteamimg pa-3" xs11 sm6 lg4>
          <div class="cardteamimg">
            <v-icon class="fal">mdi-arrow-right</v-icon>
          </div>
        </v-flex>
        <v-flex class="wrapperteamimg pa-3" xs11 sm6 lg4>
          <div class="cardteamimg">
            <v-icon class="fal">mdi-arrow-right</v-icon>
          </div>
        </v-flex>
        <v-flex class="wrapperteamimg pa-3" xs11 sm6 lg4>
          <div class="cardteamimg">
            <v-icon class="fal">mdi-arrow-right</v-icon>
          </div>
        </v-flex>
        <v-flex class="wrapperteamimg pa-3" xs11 sm6 lg4>
          <div class="cardteamimg">
            <v-icon class="fal">mdi-arrow-right</v-icon>
          </div>
        </v-flex>
      </v-layout>
    </v-container>-->
    <!-- Gallery -->

    <!-- Bubbles BG-->
    <transition name="fade">
      <div style="z-index: 0">
        <ul class="circles">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
      </div>
    </transition>
    <!-- Bubbles BG-->

    <!-- Profile  -->
    <!-- <v-dialog v-model="teamDialog" width="300">
      <v-layout>
        <v-flex xs12 style="z-index: 2">
          <v-card class="avatarcardbg text-xs-center elevation-15" dark>
            <v-card-text class="pb-1 headline">{{
              this.dialogName
            }}</v-card-text>
            <v-card-text class="pt-1 pb-2 body-2 font-weight-light"
              >Role: {{ this.dialogRole }}</v-card-text
            >
            <v-layout justify-center style="z-index: 1" wrap row class="py-4">
              <div class="teamavatar mt-3">
                <img :src="this.dialogAvatar" alt="Avatar Profile" />
              </div>
              <v-card-text class="pt-4 pb-3 mx-2 body-1 font-weight-regular">{{
                this.dialogDescription
              }}</v-card-text>
              <v-btn
                @click="teamDialog = false"
                class="mx-4 my-3 py-2"
                depressed
                block
                color="#1190bf"
                style="opacity: 0.95"
                >Alright, Cool.</v-btn
              >
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-dialog> -->
    <!-- Profile -->
  </v-app>
</template>

<script>
import GameCardsStack from "../components/GameCards";

export default {
  name: "App",
  components: {},

  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Everowl Technologies",
    // all titles will be injected into this template
    titleTemplate: "About Us | About Everowl | %s",
    meta: [
      { charset: "utf-8" },
      {
        name: "description",
        content:
          "We are Everowl Technologies, a small but enthusiastic company that specializes in both mobile and website development.",
      },
      {
        name: "keywords",
        content: "about everowl, kelf, everowl technologies, about us",
      },
    ],
  },

  data() {
    return {
      visibleCards: ["Test", "Vue.js", "Webpack"],
      teamDialog: false,
      dialogName: "",
      dialogRole: "",
      dialogDescription: "",
      dialogAvatar: "",
    };
  },

  // Used to hide the circle particles
  // mounted() {
  //   window.addEventListener('scroll', this.updateScroll);
  // },

  // destroy() {
  // window.removeEventListener('scroll', this.updateScroll)
  // },

  methods: {
    // updateScroll() {
    //   if(window.scrollY>this.$refs.myDiv.offsetHeight){
    //     this.showCircles = true
    //   } else if (window.scrollY<this.$refs.myDiv.offsetHeight) {
    //     this.showCircles = false
    //   }
    // },
    toPage(name) {
      this.$router.push({ name: name });
    },

    toCMSSection() {
      this.$store.commit("setCMSNavigationStatus", true);
      this.$router.push({ name: "Web Development" });
    },

    handleCardAccepted() {
      // console.log("handleCardAccepted");
    },

    handleCardRejected() {
      // console.log("handleCardRejected");
    },

    handleCardSkipped() {
      // console.log("handleCardSkipped");
    },

    removeCardFromDeck() {
      this.visibleCards.shift();
    },
    openDetail(person) {
      switch (person) {
        case "kelf":
          // https://www.linkedin.com/in/yew-bang-zhao-5993a4151
          window.open("https://www.linkedin.com/in/yew-bang-zhao-5993a4151");
          // this.dialogName = "Yew Kelf";
          // this.dialogRole = "Full Stack Developer";
          // this.dialogDescription =
          //   "Skilled in Mobile Application Development, Website Development, Vue.js, React, React Native, User Experience (UX) and User Interface Design. Basically a jack of all trades. And he likes latest dank memes :D";
          // this.dialogAvatar = "/img/avatar/kelf.svg";
          // this.teamDialog = true;
          break;

        case "don":
          window.open("https://my.linkedin.com/in/daniel-vineshen");
          // https://my.linkedin.com/in/daniel-vineshen
          // this.dialogName = "Daniel Vineshen";
          // this.dialogRole = "Full Stack Developer";
          // this.dialogDescription = "Teamwork makes the dream work.";
          // this.dialogAvatar = "/img/avatar/don.svg";
          // this.teamDialog = true;
          break;

        case "nick":
          window.open("https://www.linkedin.com/in/nicholas-damian-735237183/");
          // https://www.linkedin.com/in/nicholas-damian-735237183/
          // this.dialogName = "Nicholas Damian";
          // this.dialogRole = "Full Stack Developer";
          // this.dialogDescription =
          //   "Experienced in Mobile Application Development, Website Development, Vue.js, React, React Native, User Experience (UX), User Interface Design. A graduate with First-class honours, an outstanding student award, and best project award from Asia Pacific University of Technology and Innovation (APU / APIIT).";
          // this.dialogAvatar = "/img/avatar/nick.svg";
          // this.teamDialog = true;
          break;

        case "wilson":
          window.open("https://www.linkedin.com/in/lee-yi-sheng-43173b161/");
          // https://www.linkedin.com/in/lee-yi-sheng-43173b161/
          // this.dialogName = "Wilson Lee";
          // this.dialogRole = "Full Stack Developer";
          // this.dialogDescription = " 'Fortnite FTW - Wilson 2019' ";
          // this.dialogAvatar = "/img/avatar/wilson.svg";
          // this.teamDialog = true;
          break;

        default:
          break;
      }
    },
  },
};
</script>

<style>
/* Team Dialog */
.teamavatar {
  width: 120px;
  height: 120px;
  box-sizing: border-box;
  border: 3px white solid;
  border-radius: 50%;
  overflow: hidden;
  box-shadow: 0 5px 15px 0px rgba(0, 0, 0, 0.6);
  transform: translatey(0px);
  animation: float 6s ease-in-out infinite;
}
.teamavatar img {
  width: 100%;
  height: auto;
}

.avatarcardbg {
  background-image: url("/img/AbstractBg.png");
  background-attachment: inherit;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

@keyframes float {
  0% {
    box-shadow: 0 5px 15px 0px rgba(0, 0, 0, 0.6);
    transform: translatey(0px);
  }
  50% {
    box-shadow: 0 25px 15px 0px rgba(0, 0, 0, 0.2);
    transform: translatey(-10px);
  }
  100% {
    box-shadow: 0 5px 15px 0px rgba(0, 0, 0, 0.6);
    transform: translatey(0px);
  }
}
/* Team Dialog */

/* Team Gallery */
.containerteamimg .wrapperteamimg {
  transform: skew(-10deg);
  transition: 0.25s;
}
.containerteamimg .wrapperteamimg:before {
  content: "";
  left: 0;
  top: 0;
  height: calc(100% - 10px);
  width: calc(100% - 10px);
  border-radius: 40px;
  opacity: 0;
  border: 2px solid #ece9e6;
  position: absolute;
  z-index: -1;
  transition: 0.5s 0.05s;
}
.containerteamimg .wrapperteamimg:hover:before {
  opacity: 1;
  transform: translateY(1.5rem) translateX(1.5rem);
}
.containerteamimg .wrapperteamimg:nth-child(1) .cardteamimg:after {
  content: "";
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-image: url("https://images.pexels.com/photos/953219/pexels-photo-953219.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260");
  background-size: cover;
  background-color: #373f51;
  background-blend-mode: screen;
  transform: skew(10deg) scale(1.2);
  transition: 0.25s;
}
.containerteamimg .wrapperteamimg:nth-child(2) .cardteamimg:after {
  content: "";
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-image: url("https://images.pexels.com/photos/316891/pexels-photo-316891.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260");
  background-size: cover;
  background-color: #373f51;
  background-blend-mode: screen;
  transform: skew(10deg) scale(1.2);
  transition: 0.25s;
}
.containerteamimg .wrapperteamimg:nth-child(3) .cardteamimg:after {
  content: "";
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-image: url("https://images.pexels.com/photos/3303/water-drink-fresh-lemons.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260");
  background-size: cover;
  background-color: #373f51;
  background-blend-mode: screen;
  transform: skew(10deg) scale(1.2);
  transition: 0.25s;
}
.containerteamimg .wrapperteamimg:nth-child(4) .cardteamimg:after {
  content: "";
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-image: url("https://images.pexels.com/photos/635537/pexels-photo-635537.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260");
  background-size: cover;
  background-color: #373f51;
  background-blend-mode: screen;
  transform: skew(10deg) scale(1.2);
  transition: 0.25s;
}
.containerteamimg .wrapperteamimg:nth-child(5) .cardteamimg:after {
  content: "";
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-image: url("https://images.pexels.com/photos/6478/tree-lemon-fruit.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260");
  background-size: cover;
  background-color: #373f51;
  background-blend-mode: screen;
  transform: skew(10deg) scale(1.2);
  transition: 0.25s;
}
.containerteamimg .wrapperteamimg:nth-child(6) .cardteamimg:after {
  content: "";
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-image: url("https://images.pexels.com/photos/709816/pexels-photo-709816.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260");
  background-size: cover;
  background-color: #373f51;
  background-blend-mode: screen;
  transform: skew(10deg) scale(1.2);
  transition: 0.25s;
}
.containerteamimg .wrapperteamimg:hover {
  transform: translateX(-1rem) translateY(-1rem) skew(-10deg);
}
.containerteamimg .wrapperteamimg:hover .cardteamimg {
  box-shadow: 0.5rem 0.5rem 1rem rgba(0, 0, 0, 0.1);
}
.containerteamimg .wrapperteamimg:hover .cardteamimg:after {
  background-blend-mode: normal;
}
.containerteamimg .wrapperteamimg:hover .cardteamimg .fal {
  bottom: 4rem;
  background-color: rgba(255, 255, 255, 0.8);
}
.containerteamimg .cardteamimg {
  background-color: #fff;
  border-radius: 40px;
  height: 15rem;
  padding: 1.5rem;
  position: relative;
  overflow: hidden;
}
.containerteamimg .cardteamimg:after {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.containerteamimg .cardteamimg .fal {
  position: absolute;
  bottom: -1rem;
  right: 1.5rem;
  border-radius: 100%;
  padding: 1rem;
  font-size: 1.5rem;
  color: #373f51;
  z-index: 1;
  transform: skew(10deg) translateY(75%);
  text-align: center;
  transition: 0.25s;
}

/* Navigation Menu */
.education {
  --bg-color: #ffd861;
  --bg-color-light: #ffeeba;
  --text-color-hover: #4c5656;
  --box-shadow-color: rgba(255, 215, 97, 0.48);
}

.credentialing {
  --bg-color: #b8f9d3;
  --bg-color-light: #e2fced;
  --text-color-hover: #4c5656;
  --box-shadow-color: rgba(184, 249, 211, 0.48);
}

.wallet {
  --bg-color: #ceb2fc;
  --bg-color-light: #f0e7ff;
  --text-color-hover: #fff;
  --box-shadow-color: rgba(206, 178, 252, 0.48);
}

.human-resources {
  --bg-color: #dce9ff;
  --bg-color-light: #f1f7ff;
  --text-color-hover: #4c5656;
  --box-shadow-color: rgba(220, 233, 255, 0.48);
}

.customdividermini {
  width: 150px;
  text-align: center;
  border-bottom: 1px solid rgba(0, 153, 255, 0.603);
  line-height: 0.1em;
  margin-left: auto;
  margin-right: auto;
}

/*-- Space-Class --*/
.space-20 {
  height: 20px;
}

.space-80 {
  height: 80px;
}

/* Medium Layout: 1280px. */
@media only screen and (min-width: 961px) and (max-width: 1264px) {
}

/* Tablet Layout: 768px. */
@media only screen and (min-width: 601px) and (max-width: 960px) {
}

/* Mobile Layout: 320px. */
@media only screen and (max-width: 600px) {
  .mobile-image {
    display: none !important;
  }
}

/* Wide Mobile Layout: 480px. */
@media only screen and (min-width: 480px) and (max-width: 767px) {
}
</style>
